import React, { useEffect } from 'react';
import { getHelpForLocation } from './helpRegistry';
import { useEarnCatalog } from '../../utils/useEarnCatalog';
import './HelpModal.css';

/**
 * Page help dialog — glance tips + detail sections for the current route.
 */
export default function HelpModal({ pathname, search = '', onClose }) {
  const coins = useEarnCatalog();
  const help = getHelpForLocation(pathname, search, coins);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div className="page-help-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="page-help-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="page-help-modal-heading"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="page-help-modal-head">
          <h2 id="page-help-modal-heading">Help · {help.title}</h2>
          <button
            type="button"
            className="page-help-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="page-help-modal-body">
          <p className="page-help-modal-label">At a glance</p>
          <ol className="page-help-glance">
            {help.glance.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ol>

          <div className="page-help-details">
            <p className="page-help-modal-label">Details</p>
            {help.sections.map((section) => (
              <section key={section.heading} className="page-help-section">
                <h3>{section.heading}</h3>
                <p>{section.body}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
